export default __webpack_public_path__ + "static/media/toplogic-logo-home.ed436f5d.png";